<!--
  @Description 说明编辑弹窗
  @Date 2021-12-24
  @Author liushuo
-->
<template>
  <vxe-modal v-model="isShow" size="mini" width="60%" height="80%" @show="showWindows" @close="closeWindows" show-zoom>
    <!-- 标题 -->
    <template #title>
      <!-- 问题编号 -->
      <span style="color: #888888">{{ form.num || '新增问题' }}</span>
      <!-- 模块名称 -->
      <span style="margin-left: 10px">{{ `[${form.groupName}]` }}</span>
      <!-- 页面名称 -->
      <span style="margin-left: 5px">{{ form.vuePath }}</span>
    </template>

    <!-- 编辑区域 -->
    <div class="edit-dv">
      <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
        <!-- 第一行 -->
        <el-row v-if="!ifOnlyShowQuestionContent" :gutter="20">
          <el-col :span="6">
            <el-form-item label="模块" prop="groupName">
              <el-input
                v-model="form.groupName"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="系统版本" prop="productionVersion">
              <el-input
                v-model="form.productionVersion"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="当前节点" prop="result">
              <el-input
                v-model="form.result"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="说明类型" prop="result">
              <el-select clearable v-model="form.result" :placeholder="placeholderConfig.select" :disabled="true">
                <el-option
                  :index="item + ''"
                  v-for="item in combobox.result"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行 -->
        <el-row v-if="!ifOnlyShowQuestionContent" :gutter="20">
          <el-col :span="6">
            <el-form-item label="前端研发" prop="frontEngineer">
              <el-select
                clearable
                filterable
                v-model="form.frontEngineer"
                size="small"
                placeholder="选择前端人员"
                :disabled="true"
              >
                <!-- :disabled="isDisabled('frontEngineerCache')" -->
                <el-option
                  v-for="i of selectOptions.frontEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="后端研发" prop="backEngineer">
              <el-select
                clearable
                filterable
                v-model="form.backEngineer"
                size="small"
                placeholder="选择后端人员"
                :disabled="true"
              >
                <!-- :disabled="isDisabled('backEngineerCache')" -->
                <el-option
                  v-for="i of selectOptions.backEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="技术测试" prop="techTester">
              <el-select
                clearable
                filterable
                v-model="form.techTester"
                size="small"
                placeholder="选择技术测试"
                :disabled="true"
              >
                <!-- :disabled="isDisabled('techTesterCache')" -->
                <el-option
                  v-for="i of selectOptions.techTester"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务测试" prop="businessTester">
              <el-select
                clearable
                filterable
                v-model="form.businessTester"
                size="small"
                placeholder="选择业务测试"
                :disabled="true"
              >
                <!-- :disabled="isDisabled('businessTesterCache')" -->
                <el-option
                  v-for="i of selectOptions.businessTester"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="问题内容" prop="content">
              <el-input
                type="textarea"
                :rows="ifOnlyShowQuestionContent ? 15 : 8"
                v-model="form.content"
                autocomplete="off"
                :placeholder="placeholderConfig.relation"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行 -->
        <!--  先用主界面添加说明来替代，该界面的说明编辑先不开出来 -->
        <!-- <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="编辑说明" prop="bianjishuoming">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.bianjishuoming"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="true"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </div>

    <!-- 间隔槽（内含保存按钮） -->
    <div class="gap-dv">
      <button class="btn pre-next-btn" @click="toPre" :disabled="curRowPosition === 0">
        <i class="el-icon-caret-left"></i>
      </button>
      <button class="btn del-btn" :class="$parent.specialAuthority.super ? '' : 'btn-dv-prohibit'" @click="deleteItem">
        删除
      </button>
      <!-- <button
        class="btn add-btn"
        :class="$parent.Authority.edit ? '' : 'btn-dv-prohibit'"
        @click="openCooperatePersonModal"
      >
        增加协助人
      </button> -->
      <button class="btn add-btn" @click="handleTypography">
        排版问题内容
      </button>
      <button class="btn pre-next-btn" @click="toNext" :disabled="curRowPosition === curPageRowData.length - 1">
        <i class="el-icon-caret-right"></i>
      </button>
      <!-- 保存按钮暂且隐藏，该界面不做操作 <button
        class="btn save-btn"
        :class="$parent.Authority.edit ? '' : 'btn-dv-prohibit'"
        @click="save"
      >
        保存
      </button> -->
    </div>

    <!-- 历史说明区域 -->
    <div class="history-dv">
      <div class="history-title">历史说明</div>
      <div class="history-list-dv">
        <div class="history-list-item" v-for="(item, index) of historyInsList" :key="index">
          <!-- 格式化成：'1. [2021-11-20 08:20 提出] 张三：说明内容' -->
          <span style="color: #6c9eff">{{ `${index + 1}. ` }}</span>
          <span style="color: #999">{{ `[${item.date} ${item.type}] ` }}</span>
          <span style="color: #101010; font-weight: bold">{{ `${item.user}：` }}</span>
          <span>{{ item.instruction }}</span>
        </div>
      </div>
    </div>
    <!-- 协助人选择框 -->
    <CooperatePersonSelect ref="CooperatePersonSelect" :curSelectRowID="id" title="选择协助人"></CooperatePersonSelect>
  </vxe-modal>
</template>

<script>
import CooperatePersonSelect from './CooperatePersonSelect'
import { MessageBox } from 'element-ui'

export default {
  name: 'instructionEdit',
  components: {
    CooperatePersonSelect
  },
  props: {
    parentObj: Object,
    // 当前数据行id
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {},
      // 当前页的所有行（用于上一条、下一条）
      curPageRowData: [],
      rules: {},
      // 特殊权限
      spcial: false,
      frontEngineerCache: '',
      backEngineerCache: '',
      techTesterCache: '',
      businessTesterCache: '',
      // 下拉框列表
      combobox: {
        // 说明类型
        result: []
      },
      // 历史说明列表
      historyInsList: [
        // {
        //   type: '提出',
        //   date: '2021-12-20 08:28',
        //   user: '张三',
        //   instruction: '前端处理人修改为李四'
        // },
      ],
      selectOptions: {
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: []
      }
    }
  },
  methods: {
    // 排版问题内容
    handleTypography() {
      if (this.form.content) {
        let cache = this.form.content + ''
        const separator = cache.substring(1, 2)
        const re = new RegExp('([0-9]{1,3}|1000)' + '\\' + separator, 'g')
        const numList = cache.match(re)
        let resultList = []
        if (numList) {
          for (let i = 0; i < numList.length; i++) {
            // numList[i] = Number(String(numList[i]).split(separator)[0])
            if (i === 0) {
              resultList.push(numList[i])
            } else {
              if (
                Number(numList[i].split(separator)[0]) - 1 ===
                Number(resultList[resultList.length - 1].split(separator)[0])
              ) {
                resultList.push(numList[i])
              }
            }
          }
          // resultList = resultList.map(item => {
          //   return String(item) + separator
          // })
          if (resultList) {
            let isFirst = true
            for (let item of resultList) {
              if (isFirst) {
                isFirst = false
              } else {
                cache = cache.replace(item, '\n' + item)
              }
            }
            this.form.content = cache
          } else {
            this.$message.error('没有内容可以排版')
          }
        } else {
          this.$message.error('没有内容可以排版')
        }
      }
    },
    // 监听模态框开启
    async showWindows() {
      // 0107暂时不开启 this.setFormRules()
      // 获取人员下拉框
      // 0107暂时不开启 await this.getPerson()
      // 将刚打开弹窗时的所有人员作为缓存存起来，作为后续判断依据
      // 0107暂时不开启 this.setPersonCache()
    },
    // 设置表单校验规则
    setFormRules() {
      this.rules = {
        result: [
          // { required: true, message: '请选择问题结论', trigger: 'change' },
        ]
      }
    },
    // 获取人员数据
    async getPerson() {
      this.selectOptions.frontEngineer = []
      this.selectOptions.backEngineer = []
      this.selectOptions.techTester = []
      this.selectOptions.businessTester = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        // let cache = {
        //   name: item.name,
        //   value: item.id + '@' + item.num + '@' + item.name + '@' + item.post
        // }
        const temp = {
          name: item.name,
          value: item.name
        }
        // TODO 前后端、技术测试、业务测试过滤
        this.selectOptions.frontEngineer.push(temp)
        this.selectOptions.backEngineer.push(temp)
        this.selectOptions.techTester.push(temp)
        this.selectOptions.businessTester.push(temp)
      }
    },
    // 缓存弹窗中的人员，作为后续判断依据，触发时机如下：
    // 1.刚打开弹窗时
    // 2.点击保存后（暂时不用，直接关掉弹窗）
    setPersonCache() {
      // 前端
      this.frontEngineerCache = this.form.frontEngineer
      // 后端
      this.backEngineerCache = this.form.backEngineer
      // 技术测试
      this.techTesterCache = this.form.techTester
      // 业务测试
      this.businessTesterCache = this.form.businessTester
    },
    // 监听模态框关闭
    closeWindows() {
      this.$refs['FormRef'].resetFields()
    },
    // 保存
    async save() {
      if (!this.$parent.Authority.edit) {
        return false
      }

      const isCanSave = await this.validForm()
      if (!isCanSave) return

      // TODO 调用保存接口
      this.closeModal()
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('请正确填写信息')
      }
      return flag
    },
    // 打开协助人弹窗
    openCooperatePersonModal() {
      if (!this.$parent.Authority.edit) {
        return false
      }
      // 问题内容
      this.$refs.CooperatePersonSelect.form.content = this.form.content
      this.$nextTick(() => {
        this.$refs.CooperatePersonSelect.formVisible = !this.$refs.CooperatePersonSelect.formVisible
      })
    },
    // 删除
    deleteItem() {
      if (!this.$parent.specialAuthority.super) {
        return false
      }
      MessageBox.confirm('确认删除吗？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.httpDelItem()
        })
        .catch(() => {
          // do something
        })
    },
    // 发起删除请求
    async httpDelItem() {
      if (this.id < 0) {
        this.$message.error('未保存的数据不可删除')
        return
      }
      const { data: res } = await this.$http.delete('/Common/YKCase', {
        data: {
          id: this.id
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      // 重新刷新主页面（因为有删除，所以需要全量刷新）
      this.parentObj.getList()
      this.closeModal()
    },
    openModal() {
      this.isShow = true
    },
    closeModal() {
      this.isShow = false
    },
    /**
     * 输入框是否禁用
     * @param {String} property 字段名
     */
    isDisabled(property) {
      const DISABLED = true
      const ABLE = false
      // 对应的解决日期单元格，需对应的值为本人才可操作
      // TODO 获取特殊权限 1.若有特殊权限，则全部允许编辑
      if (this.$parent.specialAuthority.super) {
        return ABLE
      }

      // 2.判断缓存值，若值为 '/' 或为本人，则允许编辑
      if (this[property] === '/' || this[property] === this.curUserName) {
        return ABLE
      }

      return DISABLED
    },
    // 赋值历史说明
    setHistoryInsList(form) {
      // form.comment 说明
      const comment = form.comment
      this.historyInsList = this.formatContentWrap(comment)
    },
    /**
     * @description 格式化说明
     * @param {String} comment 说明内容
     * @returns Array[{type, date, user, instruction}]
     */
    formatContentWrap(comment) {
      let res = []
      if (comment == null || comment.trim() === '') {
        return res
      }
      // 1.按句分割
      let sentence = comment.split('!#!')
      sentence.forEach(v => {
        // 2.按字段分割，[0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:问题说明id
        const word = v.split('!&!')
        const temp = {
          type: word[0] || '无',
          date: word[1] || '无',
          user: word[2] || '无',
          instruction: word[3] || '无'
        }
        if (this.$store.state?.systemSetting?.explainSort && this.$store.state.systemSetting.explainSort === 'asc') {
          res.unshift(temp)
        } else {
          res.push(temp)
        }
      })
      return res
    },
    toPre() {
      if (this.curRowPosition <= 0) return
      this.form = this.curPageRowData[this.curRowPosition - 1]
    },
    toNext() {
      if (this.curRowPosition >= this.curPageRowData.length - 1) return
      this.form = this.curPageRowData[this.curRowPosition + 1]
    }
  },
  computed: {
    tableHeight() {
      if (this.approveDisplay) {
        return '225px'
      } else {
        return '100px'
      }
    },
    // 输入框是否禁用
    // isDisabled () {
    // 1.暂时弃用，等有 [节点] 字段再修改该逻辑 ：[当前节点] 不等于 [当前登录人]，弹窗所有输入框都不可输入
    // return false
    // },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    // 是否只显示说明内容
    ifOnlyShowQuestionContent() {
      if (
        this.$store.state?.systemSetting?.ifShowQuestionDetail &&
        this.$store.state.systemSetting.ifShowQuestionDetail === 'yes'
      ) {
        return true
      } else {
        return false
      }
    },
    // 当前行所在的索引（仅在当前分页数据内，用于上一条、下一条）
    curRowPosition() {
      return this.curPageRowData.findIndex(row => {
        return row.id === this.form.id
      })
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.setHistoryInsList(newVal)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.edit-dv {
  width: @all-dv-width;
  margin: 0 auto;
  height: calc(
    // dv-margin: 需要乘的数值 = 整体区块数量 + 1（如加了一个 gap-dv，则需要 + 1）
      100% - @history-dv-height - @dv-margin*4 - @gap-height - @gap-margin
  );
  overflow-y: scroll;
  overflow-x: hidden;
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.gap-dv {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0;
  padding-bottom: @gap-padding-bottom;
  border-bottom: 1px solid #f2f3f5;
  .fl;

  .btn {
    margin: 0 10px;
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }

  .save-btn {
    background-color: @primary-color;
    color: @text-color;
  }

  .add-btn {
    width: 100px;
    color: #666;
  }

  .del-btn {
    width: 100px;
    background-color: #ff8b8b;
    color: #fff;
  }

  .pre-next-btn {
    width: 70px;
  }
}

.btn-dv-prohibit {
  // cursor: not-allowed;
  transition: none !important;
  opacity: 0.5 !important;
  // color: #c0c4cc;
  // border-color: #ebeef5;
  // background-color: #f2f3f5;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.history-dv {
  width: @all-dv-width;
  height: @history-dv-height;
  margin: 10px auto;
  // background-color: #ffcc66;
  overflow-y: scroll;
  box-sizing: border-box;
  font-size: 14px;

  .scrollbar-mixin();

  .history-title {
    font-size: 16px;
    font-weight: bold;
    color: @able-color;
  }

  .history-list-dv {
    width: 97%;
    padding: @dv-margin auto;

    .history-list-item {
      margin: 6px 0;
    }
  }
}

.el-row {
  margin-bottom: 12px !important;
}
</style>
